import React, {useEffect, useState} from "react";
import { Card, CardHeader, CardBody, Row, Col } from "reactstrap";
import {ButtonContainer} from "@pages/reusable-components/styled-components";
import InputCustom from "@pages/components/InputCustom";
import {InputArraySelect} from "@pages/components/InputSelect";

export default function CompanyInfoTab({
                                                   company: initialCompany,
                                                   businessTypes,
                                                   companyTypes,
                                                   updateDeal,
                                                   clearMenus,
                                               }) {

    const [company, setCompany] = useState({});

    useEffect(() => {
        if (initialCompany) {
            setCompany(initialCompany);
        }
    }, [initialCompany]);

    return (
        <Card>
            <CardHeader>
                <h2>Company information</h2>
            </CardHeader>
            <CardBody>
                <Row>
                    <Col md={4}>
                        <Col>
                            <InputArraySelect
                                newLabel="Business activity"
                                value={company?.business_activity_id || ""}
                                options={businessTypes}
                                valueKey="id"
                                labelKey="name"
                                onChange={(e) =>
                                    setCompany({
                                        ...company,
                                        business_activity_id: e.target.value,
                                    })
                                }
                                defaultOption={true}
                            />
                        </Col>
                        <Col>
                            <InputArraySelect
                                newLabel="Company type"
                                value={company?.company_type_id || ""}
                                options={companyTypes}
                                valueKey="id"
                                labelKey="name"
                                onChange={(e) =>
                                    setCompany({
                                        ...company,
                                        company_type_id: e.target.value,
                                    })
                                }
                                defaultOption={true}
                            />
                        </Col>
                    </Col>

                    <Col md={4}>
                        <Col>
                            <InputCustom
                                newLabel="Company name"
                                value={company?.name || ""}
                                onChange={(e) =>
                                    setCompany({
                                        ...company,
                                        name: e.target.value,
                                    })
                                }
                            />
                        </Col>
                        <Col>
                            <InputCustom
                                newLabel="Business address"
                                value={company?.address || ""}
                                onChange={(e) =>
                                    setCompany({
                                        ...company,
                                        address: e.target.value,
                                    })
                                }
                            />
                        </Col>
                    </Col>

                    <Col md={4}>
                        <InputCustom
                            newLabel="Business phone number"
                            value={company?.phone_number || ""}
                            onChange={(e) =>
                                setCompany({
                                    ...company,
                                    phone_number: e.target.value,
                                })
                            }
                        />
                    </Col>
                </Row>

                <div className="d-flex flex-row justify-content-end mt-5">
                    <ButtonContainer onClick={clearMenus}>Cancel</ButtonContainer>
                    <ButtonContainer  reverse
                                     onClick={() => updateDeal({companyData: company})}>Update</ButtonContainer>
                </div>
            </CardBody>
        </Card>
    );
}
